import {Contract, Dependencies, Requirement, RequirementTypes} from 'interactors/contracts/types';
import {createAssert} from 'interactors/contracts/assert';

function createCheckerFor(type: RequirementTypes, settings: Dependencies = {}): () => void {
  const assert = createAssert(settings);
  const requirements = settings[type];

  return function checkRequirements(...args: unknown[]): void {
    if (!requirements) return;
    requirements.forEach((requirement: Requirement) => {
      const [expression, message] = requirement;
      assert(expression.bind(null, ...args), message);
    });
  };
}

export function createContract(settings: Dependencies = {}): Contract {
  return {
    require: createCheckerFor('require', settings),
    ensure: createCheckerFor('ensure', settings),
  };
}
